import React from 'react'
import { Box, Flex, Text, Link } from 'rebass'
import styled from 'styled-components'
import mcdLogoWhite from '../images/mcd-logo-white.svg'
import UprightLink from '../components/UprightLink'
import media from '../components/Media'

const Footer = styled(Box)`
  ${media.desktop`
    text-align: left;
  `}
`

const Logo = styled(Box)`
  background-image: url(${mcdLogoWhite});
  background-size: cover;
  background-repeat: no-repeat;
  width: 64px;
  height: 64px;
  margin: 0 auto;
`

const BrandFooter = () => (
  <Footer>
    <Flex
      flexDirection={['column', 'row']}
      alignItems={[null, 'center']}
      justifyContent={[null, 'space-between']}
    >
      <Flex
        flexDirection={['column', 'row']}
        css={{ textAlign: 'center' }}
        alignItems={[null, 'center']}
      >
        <Link href="https://mcdbooks.com">
          <Logo />
        </Link>
        <Text
          color="yellow"
          mt={[8, 0]}
          ml={[0, 8]}
          css={{ letterSpacing: '1.5px' }}
        >
          MCD × FSG
        </Text>
      </Flex>
      <Flex
        mt={[48, 0]}
        as="nav"
        flexDirection={['column', 'row']}
        justifyContent="center"
        alignItems="center"
      >
        <UprightLink
          color="yellow"
          mt={[24, 0]}
          ml={[0, 8]}
          target="_blank"
          rel="noopener"
          href="https://twitter.com/mcdbooks"
        >
          Twitter
        </UprightLink>
        <UprightLink
          color="yellow"
          mt={[24, 0]}
          ml={[0, 8]}
          target="_blank"
          rel="noopener"
          href="https://www.instagram.com/mcdbooks/"
        >
          Instagram
        </UprightLink>
        <UprightLink
          color="yellow"
          mt={[24, 0]}
          ml={[0, 8]}
          target="_blank"
          rel="noopener"
          href="https://www.facebook.com/MCDBooks/"
        >
          Facebook
        </UprightLink>
        <UprightLink
          color="yellow"
          mt={[24, 0]}
          ml={[0, 8]}
          href="https://mcdbooks.us18.list-manage.com/subscribe?u=a51fdf73467e2176b71972da6&id=2497c5a088"
          target="_blank"
          rel="noopener"
        >
          Subscribe
        </UprightLink>
      </Flex>
    </Flex>
  </Footer>
)

export default BrandFooter
